import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (<>
        {localStorage.getItem('phone') === "yes" ? null :
            <div className="nk-footer">
            <div className="container-fluid">
                <div className="nk-footer-wrap">
                    <div className="nk-footer-copyright">
                        {" "}
                        &copy; 2022 n4nairmatrimony. Designed By <a href="https://mounts.in/">Mounts</a>
                    </div>
                    <div className="nk-footer-links">
                        <ul className="nav nav-sm">
                            <li className="nav-item">
                                <Link to={`${process.env.PUBLIC_URL}/pages/terms-policy`} className="nav-link">
                                    Terms
                                </Link>
                            </li>


                        </ul>
                    </div>
                </div>
            </div>
        </div> }
    
  </>);
};
export default Footer;
